import {React, useEffect, useState} from "react";
import {MapContainer, Marker, Popup, TileLayer, useMap} from "react-leaflet";
import L from "leaflet";


function FitBounds({ positions }) {
    const map = useMap();

    useEffect(() => {
        let bounds;
        if (positions.length)
            bounds = L.latLngBounds(positions);
        else {
            bounds = L.latLngBounds(window.baukulturMap.locations.filter(p => p.lat && p.lng).map(p => [p.lat, p.lng]));
        }
        map.fitBounds(bounds, {
            padding: [20, 20],
            maxZoom: 14,
        });
    }, [positions, map]);

    return null;
}


export default function OrtMap({locations}) {

    return (
        <MapContainer
            center={[51.1657, 10.4515]} // Default: Deutschland
            zoom={6}
            style={{height: "60vh", width: "100%"}}
            scrollWheelZoom={false}
            dragging={!L.Browser.mobile}
        >
            {/* Graustufen-OpenStreetMap (CartoDB Positron) */}
            <TileLayer
                attribution="&copy; OpenStreetMap contributors &copy; CartoDB"
                url="/cartodb-proxy/{s}/light_all/{z}/{x}/{y}{r}.png"
            />

            {locations.map((item) => {
                let iconUrl = window.baukulturMap.getBestIconUrl(item.ort_type);
                if (!iconUrl) {
                    iconUrl = `${window.baukulturMap.pluginUrl}img/icon/ort-typ--akteur.svg`;
                }
                if (!item.lat && !item.lng) {
                    return '';
                }
                const icon = L.icon({
                    iconUrl: iconUrl,
                });
                return (
                    <Marker
                        key={item.id}
                        icon={icon}
                        position={[
                            parseFloat(item.lat),
                            parseFloat(item.lng),
                        ]}
                    >
                        <Popup autoPan={true}
                               autoPanPadding={[20, 20]}>
                            <a href={item.permalink}>
                            <img className="leaflet-popup-image" src={item.thumbnail} alt={item.title} />
                            <div className="leaflet-popup-words">
                                <div className="leaflet-popup-location">{item.ort_location}</div>
                                <strong className="leaflet-popup-title">{item.title}</strong>
                                <div className="leaflet-popup-types">
                                    {item.ort_type.map( type => { if (type != 'Akteure der Baukultur') {return <div>{type}</div>}})}
                                </div>
                                <span className="leaflet-popup-link">mehr</span>
                            </div>
                            </a>
                        </Popup>
                    </Marker>
                );
            })}

            <FitBounds
                positions={locations.filter(p => p.lat && p.lng).map(p => [p.lat, p.lng])}
            />
            {locations.length === 0 && <div className="leaflet-no-results">Leider gibt es keine Treffer für Ihre Suche.</div>}
        </MapContainer>
    );
}